// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2P8y4","title":"BackImages_title___D1b_","images":"BackImages_images__1iuzX"};